import React from 'react'

export default ({alignement, bloc: {background_color, image}}) => (
  <div className="block block--image">
    <div className={`tpl tpl--${alignement}`}>
      <div className="tpl__container tpl__container--img">
        <div className="tpl__bg" style={{backgroundColor: background_color}}>
          <img className="tpl__image" src={image.url} alt={image.alt} />
        </div>
        <div className="tpl__bg" style={{backgroundColor: background_color}}>
          <img className="tpl__image" src={image.url} alt={image.alt} />
        </div>
      </div>
    </div>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/Block/BlockImage/BlockImage.js